import axios from 'axios'

// import { MessageBox, Message } from 'element-ui'
// import Toast from 'vuetify-toast-snackbar'
import router from '@/router'
import store from '@/store'
import { getUserData } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // for some long process.
  timeout: 60000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const userData = getUserData()

    // console.log('request userData', userData)
    if (userData && userData.userToken.token) {
      // console.log('X-Token', userData.token)
      config.headers['X-Token'] = userData.userToken.token
      console.log('config.headers[\'X-Token\']', config.headers['X-Token'])
    }

    return config
  }, // console.log('request getToken', token)

  error => {
    // do something with request error
    console.log(error) // for debug

    return Promise.reject(error)
  },
)

// response interceptor
service.interceptors.response.use(

  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // console.log('request response', res)

    // handle blob response
    if (res.type) {
      return res
    }

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 20000) {
      // Toast({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // alert(res.message)

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired; 50016: Access Denied
      store.dispatch('system/displayError', res).then(errDisplayed => {
        if (!errDisplayed) {
          console.log('to re-login')
          if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.code === 50016) {
            // to re-login
            // MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
            //   confirmButtonText: 'Re-Login',
            //   cancelButtonText: 'Cancel',
            //   type: 'warning'
            // }).then(() => {
            //   store.dispatch('user/resetToken').then(() => {
            //     location.reload()
            //   })
            // })
            console.log('to re-login')
            store.dispatch('users/resetToken').then(() => {
              // location.reload()
              console.log('router', router)
              router.push({ path: '/login' })
            })
          }
        }
      })

      return Promise.reject(new Error(res.message || 'Error'))
    }

    return res
  },
  error => {
    store
      .dispatch('system/displayError', {
        message: error,
      })
      .then(() => {})

    // console.log(`request err${error}`) // for debug
    // Toast({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })

    return Promise.reject(error)
  },
)

export default service
